import { solutionFlow } from '@/mocks/red-packet';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function SolutionFlow() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="方案概述"
          title="一套数字红包解决方案，贯通「发、领、用、核、析」"
          subtitle="平台以数字人民币红包为权益载体，为活动主办方提供从规则配置、红包发放、商户核销到数据复盘的一站式服务。消费者领券即用，商户收款即核，主办方实时掌握活动成效。"
        />

        {/* 桌面端横向流程 */}
        <div className="mt-14 hidden lg:block">
          <div className="relative grid grid-cols-6 gap-3">
            {solutionFlow.map((node, idx) => (
              <Reveal key={node.no} delay={idx * 90}>
                <div className="relative flex flex-col items-center text-center group">
                  <div className="relative z-10 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-secondary-300 text-secondary-600 transition-all duration-300 group-hover:bg-secondary-500 group-hover:text-foreground-950 group-hover:border-secondary-500">
                    <i className={`${node.icon} text-xl`}></i>
                  </div>
                  <div className="mt-3 text-xs font-semibold text-secondary-500">{node.no}</div>
                  <div className="mt-1 text-sm font-medium text-foreground-950 whitespace-nowrap">
                    {node.title}
                  </div>
                  <div className="mt-1 text-xs text-foreground-500 leading-relaxed">{node.desc}</div>
                </div>
              </Reveal>
            ))}

            {/* 连接线 */}
            <div className="absolute top-7 left-[8%] right-[8%] h-0.5 bg-background-200">
              <div className="h-full w-full bg-gradient-to-r from-secondary-400 to-accent-400 opacity-40"></div>
            </div>
          </div>
        </div>

        {/* 移动端纵向流程 */}
        <div className="mt-10 lg:hidden">
          <div className="space-y-0">
            {solutionFlow.map((node, idx) => (
              <Reveal key={node.no} delay={idx * 60}>
                <div className="relative flex gap-4 pb-8">
                  {idx < solutionFlow.length - 1 && (
                    <div className="absolute left-7 top-14 bottom-0 w-0.5 bg-background-200"></div>
                  )}
                  <div className="relative z-10 shrink-0 w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-secondary-300 text-secondary-600">
                    <i className={`${node.icon} text-xl`}></i>
                  </div>
                  <div className="pt-2">
                    <div className="text-xs font-semibold text-secondary-500">{node.no}</div>
                    <div className="mt-1 text-base font-medium text-foreground-950">{node.title}</div>
                    <div className="mt-1 text-sm text-foreground-500 leading-relaxed">{node.desc}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}